/**
 * INotifications.ts - INotifications - Standard interface for user notifications
 * 
 * CHANGE HISTORY:
 * - 251021_0452 [97a0397] danielbeer: fix: correct automated type annotations and test scripts
 * - 251020_0732 [95fb3a1] danielbeer: fix: complete test infrastructure - all tests passing
 * - 251020_0617 [9601b37] danielbeer: feat: implement interface-based architecture with enforcement
 */
export interface INotifications {
  /**
   * Show success notification
   * @param message - Success message
   * @param options - Optional notification options
   */
  success(message: string, options?: NotificationOptions): void;

  /**
   * Show error notification
   * @param message - Error message
   * @param options - Optional notification options
   */
  error(message: string, options?: NotificationOptions): void;

  /**
   * Show warning notification
   * @param message - Warning message
   * @param options - Optional notification options
   */
  warning(message: string, options?: NotificationOptions): void;

  /**
   * Show info notification
   * @param message - Info message
   * @param options - Optional notification options
   */
  info(message: string, options?: NotificationOptions): void;
}

export interface NotificationOptions {
  duration?: number;
  position?: 'top' | 'bottom' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  dismissible?: boolean;
  action?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * Type guard to check if an object implements INotifications
 */
export function isNotifications(obj): obj is INotifications {
  return (
    obj !== null &&
    obj !== undefined &&
    typeof obj === 'object' &&
    typeof obj.success === 'function' &&
    typeof obj.error === 'function' &&
    typeof obj.warning === 'function' &&
    typeof obj.info === 'function'
  );
}
